import React, { createContext, useState, useEffect, useContext } from "react";
import { useProperties } from "../../hooks/useProperties";
import { trackListhubSearchDisplay } from "../../tracking/listhub";
import {
  type Property,
  type Filters,
  type PropertyContextType,
} from "../../types/types";

const defaultContext: PropertyContextType = {
  properties: [],
  filters: {
    price_low: undefined,
    sw: undefined,
    ne: undefined,
  },
  meta: { total_count: 0 },
  isLoading: false,
  setProperties: () => {},
  setFilters: () => {},
  clearFilters: () => {},
};

export const PropertyContext =
  createContext<PropertyContextType>(defaultContext);

export const PropertyContextProvider: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  const [filters, setFilters] = useState<Filters>({});
  const { properties, meta, isLoading } = useProperties(filters);

  useEffect(() => {
    trackListhubSearchDisplay(properties);
  }, [properties]);

  const clearFilters = () => {
    setFilters({
      ne: filters.ne,
      sw: filters.sw,
      zoom: filters.zoom,
      lat: filters.lat,
      lng: filters.lng,
      city: filters.city,
      state: filters.state,
      activeTab: filters.activeTab,
      price_high: "",
      price_low: "",
      bedrooms: "",
      bathrooms: "",
      home_type: [],
      sqft_high: "",
      sqft_low: "",
      lot_size_high: "",
      lot_size_low: "",
      year_built_high: "",
      year_built_low: "",
      listing_source: [],
    });
  };

  const setProperties = (newProps: Property[]) => {};

  return (
    <PropertyContext.Provider
      value={{
        properties,
        filters,
        meta,
        isLoading, // Agregado
        setProperties,
        setFilters,
        clearFilters,
      }}
    >
      {children}
    </PropertyContext.Provider>
  );
};

export const usePropertyContext = () => {
  const ctx = useContext(PropertyContext);
  if (!ctx) {
    throw new Error(
      "usePropertyContext must be used within a PropertyContextProvider",
    );
  }
  return ctx;
};
